// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 156 ? "f3db1054" : chunkId) + "." + {"156":"c99021f7bcf7bc82","225":"a165db3030da7e3a","616":"985e70f8ba6637c2","760":"b61a7fa3181e2391"}[chunkId] + ".js";
};